export type ThumbFeedbackValue = 'like' | 'dislike'
export type FlagFeedbackValue = 'flag'
export type FeedbackValue = ThumbFeedbackValue | FlagFeedbackValue

export const FEEDBACK_SUBMISSION_DELAY_MS = 5000
export const FEEDBACK_CONFIRMATION_DURATION_MS = 2500
